import styled from 'styled-components';

export const StyledLearnMore = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: var(--bllink-font-primary);
    font-size: 18px;
    color: #373647;
    padding: 0 41px;
    max-width: 800px;
    text-align: start;
    
    .qa-title {
        margin-bottom: 8px;
        font-weight: 700;
    }

    .middle-block {
        margin: 40px 0 71px;
    }

    .contact-info-block {
        width: 100%;

        .contacts {
            display: flex;
            justify-content: space-between;

            .clickable-info {
                color: #3366CC;
            }
        }
    }

    .back-to-payments {
        font-family: var(--bllink-font-headers);
        font-weight: 400;
        text-transform: uppercase;      
        color: #6E74FF;
        cursor: pointer;
        margin: 64px 0 24px;
    }
        
    .app-btn {
        font-family: var(--bllink-font-headers);
        font-weight: 400;
        font-size: 20px;
        height: 60px;
        position: relative;
        padding-left: ${({ ltr }) => ltr ? '' : '60px'};
        padding-right: ${({ ltr }) => ltr ? '60px' : ''};

        .arrow {
            transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
            position: absolute;
            right: ${({ ltr }) => ltr ? '10px' : ''};
            left: ${({ ltr }) => ltr ? '' : '10px'};
        }
    }


    @media screen and (max-width: 768px) {
        margin-top: -70px;
        
        .app-btn {
            width: 100%;
        }
    }
`
